import React from 'react';

import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';
import { OptionType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarGrades,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';

function GradeFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedGrades =
    useTypedSelector(getSelectedFilters).selectedParams.selectedGrades;

  const gradesOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'grades'
  );

  const handleChangeGrades = (grade: OptionType) => {
    dispatch(setCarGrades(handleChangeMultiSelect(grade, selectedGrades)));
    dispatch(setPage(1));
  };

  const handleClearGrades = () => {
    dispatch(setCarGrades([]));
    dispatch(setPage(1));
  };

  return (
    <StockFilterMultiSelect
      label="Грейд"
      options={gradesOptions}
      selectedOptions={selectedGrades}
      onChange={handleChangeGrades}
      onClear={handleClearGrades}
    />
  );
}

export default GradeFilter;
